var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.144,
    y1: 0.07,
    x2: 0.883,
    y2: 0.95,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff0303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e100ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(-929 -4076)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(929 4076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(940.498 4087.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M0,0H27V27H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M13.267,2c3.061,0,3.443.011,4.644.068a8.3,8.3,0,0,1,2.736.524,5.493,5.493,0,0,1,2,1.3,5.53,5.53,0,0,1,1.3,2,8.323,8.323,0,0,1,.524,2.736c.053,1.2.068,1.583.068,4.644s-.011,3.443-.068,4.644a8.329,8.329,0,0,1-.524,2.736,5.752,5.752,0,0,1-3.3,3.3,8.323,8.323,0,0,1-2.736.524c-1.2.053-1.583.068-4.644.068s-3.443-.011-4.644-.068a8.329,8.329,0,0,1-2.736-.524,5.752,5.752,0,0,1-3.3-3.3,8.294,8.294,0,0,1-.524-2.736C2.015,16.71,2,16.328,2,13.267s.011-3.443.068-4.644a8.294,8.294,0,0,1,.524-2.736,5.5,5.5,0,0,1,1.3-2,5.517,5.517,0,0,1,2-1.3,8.294,8.294,0,0,1,2.736-.524C9.823,2.015,10.205,2,13.267,2Zm0,5.633A5.633,5.633,0,1,0,18.9,13.267,5.633,5.633,0,0,0,13.267,7.633Zm7.323-.282A1.408,1.408,0,1,0,19.181,8.76,1.408,1.408,0,0,0,20.59,7.352ZM13.267,9.887a3.38,3.38,0,1,1-3.38,3.38A3.38,3.38,0,0,1,13.267,9.887Z",
    transform: "translate(0.236 0.236)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.f8d73dfef090f56e8391578532bd533d.svg";
export { ForwardRef as ReactComponent };